<template>
  <div :class="{'op--modal-container':true, 'hide':!showCreateGeofence}" @click="close">
    <div class="op--modal">
      <div class="op--modal-content" >
        <div class="create-box" @click.stop>
          <div class="title">{{this.formName}} Geofence</div>

          <div class="row">
            <div class="small-12 columns">
              <div class="input-field">
                <label>Geofence Name</label>
                <input type="text" v-model="geofenceName" :disabled="loading"
                  :class="{'has-error':!!error.geofenceName}" />
                <span class="error-msg" v-show="!!error.geofenceName">{{ error.geofenceName }}</span>
              </div>
            </div>
          </div>

          <div class="row" v-if="false">
            <div class="small-12 columns">
              <div class="input-field">
                <label>Geofence ID</label>
                <input type="text" v-model="geofenceID" :disabled="loading"
                  :class="{'has-error':!!error.geofenceID}" />
                <span class="error-msg" v-show="!!error.geofenceID">{{ error.geofenceID }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-12 columns">
              <div class="input-field">
                <label>
                  Navigation Address
                  <span v-show="!!centerpoint" class="center-point">({{ centerpoint }})</span>
                </label>
                <div class="autocomplete">
                  <input type="text" @keyup="query" v-on:blur="clickOut" :disabled="loading"
                    v-model="navigationAddress" :class="{'input-location':true, 'has-error':!!error.navigationAddress}" />
                  <span class="error-msg" v-show="!!error.navigationAddress">{{ error.navigationAddress }}</span>
                  <transition name="slide-down">
                    <ul class="suggestions" v-show="showSuggestion">
                      <li v-for="(item, index) in suggestions" @click="selectLocation(index)"
                        :class="{'empty':item.title === 'Sorry'}">
                        <i v-bind:class="['fas', item.icon]"></i>
                        <span>{{item.title + ', ' + item.subtitle}}</span>
                      </li>
                    </ul>
                  </transition>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="this.formName === 'Create'">
            <div class="small-6 columns">
              <div class="input-field">
                <label>Geofence Type</label>
                <select v-model="type" :disabled="loading" @change="changeType">
                  <option value="airport">Airport</option>
                  <option value="staging">Staging Lot</option>
                  <option value="restricted">Restricted Area</option>
                  <option value="servicearea">Service Area</option>
                  <option value="tracking">Tracking</option>
                </select>
              </div>
            </div>
            <div class="small-6 columns">
              <div class="input-field">
                <label>Airport Code</label>
                <input type="text" v-model="airportCode" :disabled="loading || type !== 'airport'"
                  :class="{'has-error':!!error.airportCode}" />
                <span class="error-msg" v-show="!!error.airportCode">{{ error.airportCode }}</span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-12 columns">
              <div class="input-field">
                <label>Geofence Brand</label>
                <select v-model="geofenceBrand" :disabled="loading || type !=='servicearea'">
                  <option v-for="(brand, index) in brands" :key="index" :value="brand.id">{{brand.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="small-12 columns">
              <div class="input-field">
                <label>Overlay Color</label>
                <div class="color-box">
                  <photoshop-picker v-model="overlayColor" class="overlayColor"></photoshop-picker>
                  <div class="color-blocker" v-show="loading"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="small-12 columns">
              <br/>
              <div :class="{'button cta success block':true, 'disabled':loading || airportAssoc.loading}" @click="createGeofence">{{this.formName}}</div>
              <a class="cancel" @click="close">Cancel</a>
            </div>
          </div>

          <div class="response-box" v-show="showSuccess">
            <div class="content">
              <i class="far fa-check-circle fa-4x response"></i>
              <span>Success</span>

              <div class="button cta success block xsmall" @click="refreshTable">Close</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
const request = require('browser-request')
import { Photoshop } from 'vue-color'
import airportGeofenceAPI from '@/modules/api/geofences/airport'

export default {
  name: 'geofence-create',
  components: { 'photoshop-picker': Photoshop },
  data () {
    return {
      geofenceName: '',
      geofenceID: '',
      navigationAddressObject: '',
      navigationAddress: '',
      lastNaviationAddress: '',
      centerpoint: '',
      lastCenterpoint: '',
      // autocomplete: new google.maps.places.AutocompleteService(), // eslint-disable-line no-undef
      // geocoder: new google.maps.Geocoder(), // eslint-disable-line no-undef
      queryToken: null,
      suggestions: [],
      showSuggestion: false,
      clickOutDelay: '',
      centerpoint: '',
      type: 'airport',
      airportCode: '',
      overlayColor: '000000',
      error: {
        geofenceName: '',
        // geofenceID: '',
        navigationAddress: '',
        airportCode: ''
      },
      loading: false,
      showSuccess: false,
      geofenceBrand: '',
      formName: 'Create',
      kmlFile: '',
      isClone: false,
      airportAssoc: {
        loading: false,
        id: '',
        count: 0
      },
      triggerRefreshCounter: 0
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    showCreateGeofence () { return this.$store.state.geofences.showCreateGeofence },
    cloneFormId () { return this.$store.state.geofences.cloneId }
  },
  methods: {
    close () {
      if (this.loading) { return }

      this.$store.commit('geofences/setShowCreateGeofence', false)
      this.$store.commit('geofences/setCloneGeofence', 0)
      this.geofenceName = ''
      this.geofenceID = ''
      this.navigationAddress = ''
      this.type = 'airport'
      this.airportCode = ''
      this.overlayColor = ''
      this.centerpoint = ''
      this.geofenceBrand = ''
      this.formName = 'Create'
      this.showSuccess = false
    },
    query () {
      let self = this

      let queryText = self.navigationAddress
      if (queryText === '') {
        self.queryToken = null
        self.suggestions = []
        self.showSuggestion = false
        return
      }

      // self.generateQueryToken()

      self.showSuggestion = true
      const restrictedTypes = [
        'locality', 'postalCodePoint', 'administrativeArea',
        'chainQuery', 'categoryQuery'
      ]

      let url = 'https://autosuggest.search.hereapi.com/v1/autosuggest?at={AT}&q={SEARCH}&apiKey={API_KEY}&lang=en-US'
      url = url.replace('{AT}', encodeURIComponent(33.942791 + ',' + -118.410042))
        .replace('{SEARCH}', queryText)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err || body.items.length === 0) {
          self.suggestions = [{
            icon: 'fa-exclamation-triangle',
            title: 'Sorry',
            subtitle: 'We coudn\'t locate "' + queryText + '"'
          }]
          return
        }

        let result = []
        body.items.forEach(function (prediction) {
          if (restrictedTypes.indexOf(prediction.resultType) === -1) {
            let subtitle = prediction.address.label
            result.push({
              id: prediction.id,
              title: prediction.title,
              subtitle: subtitle,
              icon: 'fa-map-marker'
            })
          }
        })

        self.suggestions = result.slice(0, 5)
      })
    },
    clickOut () {
      let self = this
      self.clickOutDelay = setTimeout(function () {
        self.centerpoint = self.lastCenterpoint
        if (self.navigationAddress !== self.lastNaviationAddress) {
          self.centerpoint = ''
        }
        self.showSuggestion = false
      }, 300)
    },
    selectLocation (index) {
      let self = this
      let place = self.suggestions[index]
      self.queryToken = null

      clearTimeout(self.clickOutDelay)
      self.showSuggestion = false

      let url = 'https://lookup.search.hereapi.com/v1/lookup?source=sharing&id={LOCATION_ID}&locationattributes=tz&apiKey={API_KEY}&lang=en-US'
      url = url.replace('{LOCATION_ID}', place.id)
        .replace('{API_KEY}', CONFIG.hereApi.key)
      request.get({
        url: url,
        json: true
      }, function (err, res, body) {
        if (err) {
          console.log('geocode ERROR', results, status)
          self.loading = false
          return
        }

        let result = body
        let lat = result.position.lat
        let lng = result.position.lng
        self.centerpoint = lat + ', ' + lng

        let navigationAddressObject = {
          title: result.title,
          address1: result.address.street || result.title,
          address2: result.address.houseNumber || result.address.district,
          city: result.address.city,
          state: result.address.state,
          zip: result.address.postalCode,
          country: result.address.countryCode,
          lat: lat,
          lng: lng
        }

        self.navigationAddressObject = navigationAddressObject
        self.navigationAddress = self.navigationAddressObject.title
        self.lastNaviationAddress = self.navigationAddress
        self.lastCenterpoint = self.centerpoint
      })
    },
    changeType () {
      if (this.type !== 'airport') { this.airportCode = '' }
      if (this.type !== 'servicearea') { this.geofenceBrand = ''}
    },
    createGeofence () {
      let self = this

      if (self.loading) { return }

      // Validation
      self.error = {
        geofenceName: '',
        // geofenceID: '',
        navigationAddress: '',
        airportCode: ''
      }
      let hasError = false
      for (let field in self.error) {
        if (self[field] === '' && field === 'airportCode') {
          if (self.type === 'airport') {
            self.error[field] = 'This field cannot be empty.'
            hasError = true
          }
        } else if (self[field] === '') {
          self.error[field] = 'This field cannot be empty.'
          hasError = true
        }
      }
      if (self.centerpoint === '') {
        self.error.navigationAddress = 'Invalid address.'
        hasError = true
      }

      if (hasError) { return }

      self.loading = true
      let request = {
        token: self.$store.state.session.sessionToken,
        name: self.geofenceName,
        description: self.geofenceName,
        overlayColor: self.overlayColor.hex ? self.overlayColor.hex.substring(1, self.overlayColor.hex.length) : self.overlayColor,
        centerPoint: self.centerpoint,
        type: self.type,
        airportCode: self.airportCode || null,
        kmlFile: self.kmlFile,
        location: self.navigationAddressObject
      }

      let newGoefenceID = ''
      if (self.type !== 'servicearea') {
        self.$sdk.post('/geofences', request, r => {
          self.loading = false
          if (r.error) { return }
          // self.showSuccess = true
          self.refreshTable()
        })
      } else {
        request["brandId"] = self.geofenceBrand
        self.$sdk.post('/servicearea', request, r => {
          if (r.error) { return }
          self.triggerRefreshCounter = 0

          if (self.cloneFormId && self.cloneFormId > 0) {
            newGoefenceID = r.id
            if (self.airportAssoc.id) {
              airportGeofenceAPI.addSubGeofence(self, {
                id: self.airportAssoc.id,
                subID: newGoefenceID,
                priority: 9999
              }, function (r2) {
                if (!r2.error) {
                }
              })
            }

            let latLng = self.centerpoint.split(', ')
              self.$sdk.post('/geofences/' + newGoefenceID + '/polygon', {
                token: self.$store.state.session.sessionToken,
                kmlUrl: self.kmlFile,
                lat: parseFloat(latLng[0]),
                lng: parseFloat(latLng[1])
              }, r3 => {
                self.loading = false
                self.triggerRefreshCounter++
                self.triggerRefresh()
              })
          
            let geofenceList = self.$store.state.geofences.geofences.items
            let index = geofenceList.findIndex(x => x.id === self.cloneFormId)
            if (index > -1) {
              self.$sdk.post('/geofences/' + newGoefenceID, {
                token: self.$store.state.session.sessionToken,
                resTypeASAP: geofenceList[index].allowASAP,
                resTypeFuture: geofenceList[index].allowFuture,
                trackEntryExit: geofenceList[index].trackEntryExit,
                showInAppBanner: geofenceList[index].showInAppBanner,
                pushNotificationToProvUponEntry: geofenceList[index].pushNotificationToProvUponEntry,
              }, r3 => {
                console.log('r3', r3)
                self.triggerRefreshCounter++
                self.triggerRefresh()
              })
            }
          } else {
            self.loading = false
            self.refreshTable()
          }

        }, '2.0')
      }
    },
    triggerRefresh () {
      if (this.triggerRefreshCounter >= 2) {
        this.refreshTable()
      }
    },
    refreshTable () {
      this.$store.commit('geofences/setRefreshList', true)
      this.close()
    }
  },
  watch: {
    showCreateGeofence: function (value) {
      if (!value) {
        this.kmlFile = ''
        this.isClone = true
        this.airportAssocId = {
          loading: false,
          id: '',
          count: 0
        }
      }
    },
    cloneFormId: function (value) {
      if(value > 0) {
        let self = this
        let geofences = this.$store.state.geofences.geofences.items
        let index = geofences.findIndex(x => x.id === value)

        let clone = geofences[index]
        self.geofenceName = clone.name
        self.navigationAddress = clone.addressLine1 + ' ' + clone.addressLine2 + ', ' + clone.city + ', ' + clone.state + ' ' + clone.zipCode
        self.type = 'servicearea'
        self.overlayColor = clone.color
        self.formName = 'Clone'
        self.centerpoint = clone.lat + ', ' + clone.lng
        self.navigationAddressObject = {
          title: self.navigationAddress,
          address1: clone.addressLine1,
          address2: clone.addressLine2,
          city: clone.city,
          state: clone.state,
          zip: clone.zipCode,
          lat: clone.lat,
          lng: clone.lng
        }
        self.kmlFile = clone.kmlFile
        self.isClone = true

        self.airportAssoc.loading = true
        self.$sdk.get('/geofences/' + value + '/airport', {
          token: self.$store.state.session.sessionToken
        }, res => {
          self.airportAssoc.loading = false
          if (!res.error) {
            if (res.airports.length) {
              self.airportAssoc.id = res.airports[0].id
            }
          }
        })
        // airports/12/subgeofences/242
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}
.create-box{
  width: 100%;
  max-width: 500px;
  background: #fff;
  margin: 0 auto;
  padding-bottom: 20px;
  border-radius: 3px;
  position: relative;

  .title{
    font-size: 21px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 25px;
    padding: 10px;
    color: #FFF;
    background: #333;
    border-radius: 3px 3px 0 0;
  }
  .row{
    width: 100%;
    padding: 0 20px;
    margin-bottom: 10px;

    .small-6:first-child{ padding-right: 10px; }
  }
  .cancel{
    display: block;
    text-align: center;
    font-size: 14px;
    margin: 10px 0 0;
    color: #999;
    cursor: pointer;
  }
}
.input-field {
  font-size: 14px;

  label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }
  input {
    margin-top: 0;
    padding: 7px 10px;

    &.has-error{ border-color: #fb2d2d; }
  }
  select{
    padding: 7px 3px;
    border-color: #ccc;
    background-color: #fff;

    &:disabled{ background: #ebebe4; }
  }
  .error-msg{
    display: block;
    font-size: 12px;
    color: #fb2d2d;
    font-style: italic;
  }
  .center-point{
    color: #888;
    display: inline-block;
    margin-left: 5px;
  }
}

.autocomplete{
  position: relative;
  width: 100%;
}
.input-location{
  margin: 5px 0 0;
  color: #333;
  line-height: inherit;
  transition: all .15s ease;

  &.loading{ padding-right: 40px; }
  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background: #eee; }
}
.suggestions{
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 150px;
  z-index: 2;
  list-style: none;
  overflow: auto;
  padding: 0;
  margin: 0;
  box-shadow: 1px 1px 4px rgba(0,0,0, .3);

  li{
    background: #f6f6f6;
    padding:8px 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    border-bottom: 1px solid #bbb;
    color: #333;

    &:last-child{ border-bottom: none; }
    i{ margin-right: 5px; }
    span{ font-size:13px; }
    .fa-exclamation-triangle{ color: #e2c84a;}
    .fa-map-marker{ color: #ea5c5c;}
    &:hover{
      background: #0D79F2;
      color: #fff;

      i{ color: #fff; }
    }
    &.empty{ cursor: default; }
  }
}

.color-box{ position: relative; }
.color-blocker{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(255, 255, 255, .4);
}

.response-box{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .3);

  .content{
    width: 300px;
    position: absolute;
    top: 50%;
    left: 100px;
    transform: translateY(-50%);
    padding: 20px;
    background: #fff;
    text-align: center;
    color: #33c761;

    span{
      display: block;
      font-size: 21px;
      margin: 5px 0 10px;
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .create-box {
    max-width: none;
    width: 100vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceCreate.vue